module.exports = __webpack_public_path__ + "img/home-bg.439061e5.jpg";